import { render, staticRenderFns } from "./UploadSelectedMemberPhoto.vue?vue&type=template&id=3b7fde30"
import script from "./UploadSelectedMemberPhoto.vue?vue&type=script&lang=js"
export * from "./UploadSelectedMemberPhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadSelectedMemberPhoto.vue?vue&type=style&index=0&id=3b7fde30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports